import PropTypes from 'prop-types';
import { AdvancedCombobox } from '@evertrue/et-components';

const SolicitorTitle = ({ titleState, solicitor, solicitorTitles, handleChange }) => (
  <>
    {titleState === 'hidden' ? null : (
      <div className="proposal-form--solicitor-required">
        {titleState === 'required' && !solicitor.title && (
          <label className="form-field--label-wrap">
            <span className="form-field--required">Required</span>
          </label>
        )}
        <AdvancedCombobox
          className="proposal-form--solicitor-title"
          options={solicitorTitles}
          value={{ value: solicitor.title }}
          placeholder="Select a title..."
          onChange={(title) => handleChange(solicitor.contact_id, { title: title.value })}
        />
      </div>
    )}
  </>
);

SolicitorTitle.propTypes = {
  solicitor: PropTypes.shape({
    contact_id: PropTypes.number,
    name: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
  }),
  titleState: PropTypes.string,
  handleChange: PropTypes.func,
  solicitorTitles: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
};

export default SolicitorTitle;
